import React, { Component } from 'react';
import { sendEvent } from '../../helpers/analytics'

class TestStart extends Component {
  state = {
    inputChecked: false
  }

  nextScreen = () => {
    if (this.state.inputChecked) {
      this.props.next(1)
      sendEvent('game', 'click', 'start')
    }

  }

  checkAgreement = () => {
    console.log((!this.state.inputChecked).toString())
    localStorage.setItem('agree', (!this.state.inputChecked).toString())
    this.setState({inputChecked: !this.state.inputChecked})
    sendEvent('game', 'click', 'agree')
  }

  render () {
    let buttonClasses = "button button--primary";
    if (this.state.inputChecked) buttonClasses += " button--active"
    return (
      <div className="test__start">
        <h1 className="h1 h1--start">тест на скорость</h1>
        <div className="start__text">
          <p>Хорошо ли вы знаете спортивную историю Porsche? Отвечайте на вопросы о спортивной истории Porsche, и занимайте место в турнирной таблице знатоков. Чем быстрее и точнее ваши ответы — тем выше ваше место и больше шансов получить сертификат на программу <a href="https://porsche-russland.ru/pdc/intro/?utm_source=Championat&utm_medium=SP&utm_campaign=Special_Project" target="_blank" rel="noopener noreferrer">Introduction to Porsche.</a></p>
        </div>

        <div className="start__button">
          <button className={buttonClasses} onClick={this.nextScreen}>Начать тест</button>

        </div>
        <div className="start__agreement">
          <label >
            <input type="checkbox" checked={this.state.inputChecked} onChange={() => this.checkAgreement()} />
            <span>Я согласен с <a href="/rules.pdf" target="_blank" onClick={() => sendEvent('game', 'click', 'rules')}>условиями участия в конкурсе</a> и с <a href="/personal.doc" target="_blank"  onClick={() => sendEvent('game', 'click', 'personal-data')}>условиями обработки персональных данных</a>.</span>
          </label>
        </div>
      </div>
    )
  }
}

export default TestStart


// WEBPACK FOOTER //
// ./src/pages/test/start.js